import React from 'react';

let BackDrop = (props) => {
    return (
        <div className="BackDrop" onClick={props.toggle}>{props.children}</div>
    );
} 

export default BackDrop;


// WEBPACK FOOTER //
// ./src/Containers/LandingPage/Components/Modal/BackDrop.js